export default function isGoogleLocationId(locationId) {
    return locationId.substr(0, 7) === 'google_';
}
